<template>
  <v-btn-toggle
    v-bind="$attrs"
    v-on="$listeners"
    active-class="activeButton"
    color="primary"
    v-model="toggleCardView"
    mandatory
    style="background-color: rgb(244, 244, 247); padding-left: 24px;"
  >
    <v-btn
      aria-label="grid"
      :aria-pressed="gridActive.toString()"
      @click="leftClickHandler"
    >
      <v-icon>grid_on</v-icon>
    </v-btn>
    <v-btn
      aria-label="list"
      :aria-pressed="listActive.toString()"
      @click="rightClickHandler"
    >
      <v-icon>list</v-icon>
    </v-btn>
  </v-btn-toggle>
</template>

<script>
export default {
  name: "ToggleButtonGroup",
  props: {
    leftClickHandler: {
      type: Function,
      default: () => {
      },
    },
    rightClickHandler: {
      type: Function,
      default: () => {
      }
    }
  },
  data: function () {
    return {
      toggleCardView: 0,
    }
  },
  computed: {
    gridActive: function () {
      return this.toggleCardView === 0;
    },
    listActive: function () {
      return this.toggleCardView === 1;
    }
  }
}
</script>

<style lang="scss" scoped>
.activeButton {
  background-color: #041E42 !important;

  .v-icon {
    color: #fff !important;
  }
}

.activeButton:focus {
  outline: 3px solid -webkit-focus-ring-color !important;
}
</style>
